import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useEffectOnce } from 'react-use';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { ANNUITY_TYPE_OPTIONS, AnnuityType as AnnuityTypes } from '../../AccountForm.meta';
import { Toggle } from '../../../../../../../../CommonComponents/OPL/Toggle/Toggle';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { AccountModalUsageContext } from '../../context/AccountFormProvider.meta';

export const SelectAnnuityType = () => {
  const { control, register, watch, setValue } = useFormContext();
  const { setAlert, usageContext } = useAccountFormContext();

  const [positions, annuityType] = watch(['bankAccount.Positions', 'bankAccount.AnnuityType']);

  useEffectOnce(() => {
    if (
      usageContext === AccountModalUsageContext.AnnuityPurchaseWhatIf &&
      annuityType === undefined
    ) {
      setValue('bankAccount.AnnuityType', AnnuityTypes.Fixed);
    }
  });

  return (
    <>
      <Controller
        control={control}
        name="bankAccount.AnnuityType"
        render={({ field: { value, onChange, ...field } }) => {
          return (
            <Select
              {...field}
              options={ANNUITY_TYPE_OPTIONS}
              value={ANNUITY_TYPE_OPTIONS.find(option => option.value === value)}
              label="Annuity Type"
              onChange={opt => {
                onChange(opt?.value);

                if (opt?.value === AnnuityTypes.Fixed && positions.length > 0) {
                  setAlert({
                    type: 'info',
                    message:
                      'Changing to a fixed annuity will result in the removal of your holdings.',
                  });
                }
              }}
            />
          );
        }}
      />

      <Toggle {...register('bankAccount.AnnuityIsQualified')}>Qualified</Toggle>
    </>
  );
};
